import React from "react";
import { Checkbox, Form, message, Modal, Skeleton } from "antd";

import { useFetchConstant } from "apis/constant";

import FormInput from "components/FormInput/FormInput";
import FormSelection from "components/FormSelection/FormSelection";
import Locale from "react-intl-universal";

const { useForm, Item: FormItem } = Form;

const AddLoanModal = ({ visible, onOk, onCancel, defaultValues }) => {
  const [form] = useForm();
  const {
    isLoading: isLoanTypesLoading,
    selection: loanTypes,
  } = useFetchConstant("loanTypes");

  const handleOnOkButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  return (
    <Modal
      title={Locale.get("addNewAdvisee.loanSection.loanModalTitle")}
      visible={visible}
      okText={Locale.get("addNewAdvisee.loanSection.saveLoanButton")}
      onOk={handleOnOkButtonClick}
      onCancel={onCancel}
    >
      {isLoanTypesLoading ? (
        <Skeleton active />
      ) : (
        <Form form={form} initialValues={defaultValues}>
          <FormSelection
            label={Locale.get("addNewAdvisee.loanSection.loanType")}
            name="type"
            placeholder={Locale.get(
              "addNewAdvisee.loanSection.loanTypePlaceholder"
            )}
            requiredErrorMessage={Locale.get(
              "addNewAdvisee.loanSection.errMsgLoanType"
            )}
            selections={loanTypes}
          />
          <FormInput
            label={Locale.get("addNewAdvisee.loanSection.monthlyPayment")}
            name="amount"
            placeholder="0.00"
            type="financial"
            requiredErrorMessage={Locale.get(
              "addNewAdvisee.loanSection.errMsgMonthlyPayment"
            )}
          />
          <FormInput
            label={Locale.get("addNewAdvisee.loanSection.loanBalance")}
            name="loanBalance"
            placeholder="0.00"
            type="financial"
            requiredErrorMessage={Locale.get(
              "addNewAdvisee.loanSection.errMsgLoanBalance"
            )}
          />
          <FormItem name="isInsuranceCovered" valuePropName="checked">
            <Checkbox>
              {" "}
              {Locale.get("addNewAdvisee.loanSection.checkBox_0")}
            </Checkbox>
          </FormItem>
        </Form>
      )}
    </Modal>
  );
};

export default AddLoanModal;
